@if (notification.title || subject) {
  <a href="javascript:void(0)" class="notification-item" [class.unread]="!notification.seen" (click)="action()" [attr.aria-label]="notification.title || subject">
    @if (notification.topics && notification.topics[0] && userService.notificationTopicColors[notification.topics[0]]) {
      <div class="color-bar" [ngStyle]="{ 'background-color': userService.notificationTopicColors[notification.topics[0]] }"></div>
    }
    <!-- <div class="unread-badge m-l-5" *ngIf="!notification.seen"></div> -->
    <div class="notification-img">
      @if (photo || notification.photo) {
        <img class="round image-border" [alt]="'Notification image ' + (notification.title || subject)" [src]="photo || notification.photo" />
      }
    </div>
    <div class="notification-data">
      <span class="d-block t-10 text-muted">{{ notification.created.toDate() | date: "MMM Do [at] hh:mm" : true }}</span>
      <span class="subject">{{ notification.title || subject }}</span>
      <span class="extra-info">
        <span class="d-block description" [innerHTML]="notification.body || description"></span>
        @if (notification.payload?.original_post) {
          <span class="d-block original-post-text">
            Replying to:
            <div [innerHTML]="notification.payload?.original_post.message"></div>
          </span>
        }
      </span>
      @if (extraMessage) {
        <div [innerHTML]="extraMessage | safe: 'html'"></div>
      }
      @if (actions) {
        <div class="m-t-20">
          @for (item of actions; track item) {
            <span [class]="item.class" (click)="item.action($event)">{{ item.title }}</span>
          }
        </div>
      }
    </div>
    <div class="buttons">
      <fa-icon icon="times" class="m-l-5 m-r-10" (click)="delete($event)"></fa-icon>
      <!-- <fa-icon icon="chevron-right" class="m-l-5" *ngIf="includeChevron"></fa-icon> -->
    </div>
  </a>
}
